import { RavenBadge, RavenTable, RavenTableRow } from '@ravenpay/raven-bank-ui';
import React, { useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import {
	formatNumWithCommaNaira,
	getActionNamesByPolicyName,
	symbol,
} from '../../../../../../../../utils/helper/Helper';
import DateFragmentBox from '../../../../../../../../components/common/DateFragmentBox';
import { ALL_ROUTES } from '../../../../../../../../routes/dashboard/overview/AllPathNames';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import RootState from '../../../../../../../../redux/types';
import { icons } from '../../../../../../../../assets/icons';
import { FaRegEye } from 'react-icons/fa';

const TerminalTable = ({
	tableData,
	loading,
	amount_key,
}: {
	tableData: { data: [] };
	loading: boolean;
	amount_key: 'volume' | 'cash_in';
}) => {
	const navigate = useNavigate();

	function handleView(serial: string) {
		localStorage?.setItem('single-ter-serial', serial);
		navigate({
			pathname: ALL_ROUTES?.SINGLE_MERCHANT_VIEW_BANKBOX,
		});
	}

	const mapKey = {
		volume: 'volume',
		cash_in: 'cash in',
	};

	return (
		<RavenTable
			action={false}
			// className="table__main"
			headerList={[
				'Label',
				'Serial No.',
				mapKey[amount_key],
				'Date Created',
				'Status',
				//'Action',
			]}
		>
			<>
				{' '}
				{tableData?.data?.map((chi: any, idx: number) => {
					return (
						<React.Fragment key={idx}>
							<RavenTableRow
								className="table__main"
								onRowClick={() => handleView(chi?.serial)}
								one={
									loading ? (
										<Skeleton width={100} height={20} />
									) : (
										<p>{chi?.tid_label}</p>
									)
								}
								two={
									loading ? (
										<Skeleton width={100} height={20} />
									) : (
										<p>{chi?.serial}</p>
									)
								}
								three={
									loading ? (
										<Skeleton width={100} height={20} />
									) : (
										symbol('ngn') + formatNumWithCommaNaira(chi?.[amount_key])
									)
								}
								four={
									loading ? (
										<Skeleton width={100} height={20} />
									) : (
										<DateFragmentBox date={chi?.created_at} />
									)
								}
								five={
									loading ? (
										<Skeleton width={100} height={20} />
									) : (
										<RavenBadge
											text={chi?.status === 1 ? 'Active' : 'Inactive'}
											type={chi?.status === 1 ? 'green' : 'red'}
										/>
									)
								}
								/* six={
									loading ? (
										<Skeleton width={100} height={20} />
									) : (
										<div onClick={(e) => e.stopPropagation()}>
										</div>
									)
								} */
							/>
						</React.Fragment>
					);
				})}
			</>
		</RavenTable>
	);
};

export default TerminalTable;
